import lifeExpensessIcon from '../../../../../assets/icons/svg/colored-icons/ic-colored-categorization-personal.svg';
import workExpenseIcon from '../../../../../assets/icons/svg/colored-icons/ic-colored-categorization-business.svg';
import approveIncomeIcon from '../../../../../assets/icons/svg/colored-icons/ic-colored-categorization-approve.svg';
import notNowIncomeIcon from '../../../../../assets/icons/svg/colored-icons/ic-colored-categorization-reload.svg';
import splitIcon from '../../../../../assets/svg/categorization-icons/split-icon.svg';

export const STYLES = {
  MAIN_TITLE:
    'relative w-full font-metricMedium text-[16px] text-bw08 before:content-titleCardIcon before:absolute before:translate-y-[15px] before:translate-x-[-0%] before:left-[14px] pl-[45px] before:top-[5px] before:h-fit before:w-[24px] pt-[18px] pb-[12px] hover:bg-bw02 rounded-[6px]',
  MAIN_SECTION: {
    WRAPPER: 'w-full h-[280px] relative mb-[36px] fadeIn',
    CARD_WRAPPER:
      'shadow-light w-[206px] h-[243px] rounded-[8px] absolute top-0 left-[50%] translate-x-[-50%] translate-y-[7%] bg-bw00',
    CARD_ROTATE_LEFT: '-rotate-6',
    CARD_ROTATE_RIGHT: 'rotate-6',
    CARD_ICON_WRAPPER:
      'flex justify-center items-center rounded-[50%] w-[60px] max-w-[60px] h-[60px] max-h-[60px] mb-[20px] mt-[20px] border border-bw03 shadow-light',
    CARD_ICON: 'w-[70%] h-[70%]',
    CARD_CONTENT: 'font-metric text-[14px] text-center text-bw08 w-full truncate cursor-pointer max-w-[80%]',
    CARD_CONTENT_TT: 'font-metric text-bw08 text-[12px] w-[300px] text-center',
    CARD_DATE: 'text-bw06 font-metricR text-[12px] mt-[17px]',
    CATEGORY_TAX_ID_PICKER_WRAPPER: 'absolute flex flex-col bg-bw00 rounded-md right-0 top-0 w-full h-full',
    CATEGORY_TAX_ID_PICKER_TITLE: 'text-bw08 font-metricMedium text-[16px] ml-[10px]',
    CATEGORY_TAX_ID_PICKER_SCROLL_CONTAINER:
      'w-full h-full flex flex-col pt-[10px] pb-[10px] px-[20px] overflow-y-auto',
    CATEGORY_TAX_ID_PICKER_ITEM:
      'px-[14px] hover:rounded-2xl hover:bg-bw02 w-full flex items-center text-[14px] font-metric hover:text-action04 border-b border-bw02 py-[16px]',
    CATEGORY_TAX_ID_PICKER_ITEM_SELECTED: 'bg-action01 text-action04 rounded-2xl',
    CATEGORY_TAX_ID_PICKER_ICON_WRAPPER: 'w-[20px] max-w-[20px] h-[20px] max-h-[20px] mr-[10px]',
    CATEGORY_TAX_ID_PICKER_ICON: 'w-full h-full object-contain relative top-[-1px]',
    CATEGORY_TAX_ID_PICKER_FOOTER:
      'flex items-center justify-center relative bottom-0 w-full py-[14px] px-[18px] bg-bw00 border-t border-bw03 rounded-b-[8px]',
    CATEGORY_TAX_ID_PICKER_FOOTER_CTA:
      'bg-action03 hover:bg-action04 py-[10px] w-full rounded-[3.77px] text-bw00 font-metricRMedium text-sm',
    CATEGORY_TAX_ID_PICKER_PERSONAL_CTA:
      'bg-bw00 text-action03 hover:text-action04 w-[145px] h-[41px] rounded-[3.77px] font-metricRMedium text-sm',
    CATEGORY_TAX_ID_PICKER_BUSINESS_CTA:
      'bg-action03 hover:bg-action04 text-bw00 w-[145px] h-[41px] rounded-[3.77px] font-metricRMedium text-sm',
    ACTION_BUTTONS:
      'relative w-[50px] z-[5] h-[50px] shadow-circle-md rounded-[50%] border-bw03 border-solid border-[1px] bg-none hover:bg-bw02 mb-[8px]',
    ACTION_SPLIT_BTN:
      'relative w-[35px] z-[5] h-[35px] shadow-circle-md rounded-[50%] border-bw03 border-solid bg-none hover:bg-bw02 mb-[8px]',
  },
  RANGE_PICKER: {
    RANGE_PICKER_LABEL:
      'block font-metricR text-bw08 text-[14px] text-center mt-[35px] pt-[16px] border-t border-bw03 mb-[80px]',
    TOOLTIP_DIVIDER: 'h-[37px] w-[1px] bg-[#C5CCDC] mx-[6px]',
    TOOLTIP_WRAPPER:
      'flex items-center justify-center mb-[12px] w-fit absolute top-0 left-[50%] translate-x-[-50%] translate-y-[-50px]',
    TOOLTIP_TEXT: 'text-bw08 font-metric text-[20px] min-w-[30px]',
    SPLITTING_RESULT_WRAPPER: 'flex justify-between mt-[20px]',
    SPLITTING_RESULT_BOX: 'min-w-[56px] flex items-center p-[5px] gap-[16px]',
    ICON_PERSONAL: 'w-[42px] ',
    ICON_BUSINESS: 'w-[42px] ',
  },
  ROLLING_NUMBER: 'font-metricMedium text-[22px] truncate',
  FOOTER: {
    WRAPPER: 'text-sm font-metric text-bw07 mt-[40px]',
  },
};

export const RANGE_PICKER_TEXT = {
  LABEL: 'Choose how to split this transaction',
} as const;

export const ACTIONS = {
  EXPENSES: [
    {
      imgUrl: lifeExpensessIcon,
      actionType: 'categorizeLife',
      title: '',
    },
    {
      imgUrl: splitIcon,
      actionType: 'categorizeSplit',
    },
    {
      imgUrl: workExpenseIcon,
      actionType: 'categorizeWork',
      title: '',
    },
  ],
  INCOME: [
    {
      imgUrl: notNowIncomeIcon,
      actionType: 'categorizeNotNow',
      title: 'Not Now',
    },
    {
      imgUrl: approveIncomeIcon,
      actionType: 'categorizeApprove',
      title: 'Approve',
    },
  ],
};

export const CATEGORIZATION_TYPES = {
  INCOME: 'INCOME',
  EXPENSE: 'EXPENSE',
};

export const ACTION_TYPES = {
  LIFE: 'categorizeLife',
  WORK: 'categorizeWork',
  APPROVE: 'categorizeApprove',
  NOT_NOW: 'categorizeNotNow',
  SPLIT: 'categorizeSplit',
  CHOOSE_CATEGORY: 'chooseCategory',
};

export const COMPONENT_MODES = {
  NOT_ELIGIBLE: 0,
  ZERO_STATE: 1,
  LIMITED_NON_SWITCH: 2,
  UNLIMITED: 3,
  PRE_DATA_LOAD: 4,
};

export const DEFAULT_TAX_ID = 'ECC7C222-5018-6AF3-9782-C2F296E16BB0';

export const DEFAULT_INCOME_TAX_ID = '6c5e839e-9ca5-47e9-9daa-6245cdc75d47';

export const CATEGORIZE_LIFE = 'categorizeLife';

export const BUSINESS_PERCENT = {
  LIFE: 0,
  WORK: 1,
};

export const ANIMATION_DURATION_MS = 800;

export const CARD_ICON_CDN_BASE_URL = 'https://assets.lili.co/webapp/categories/';

export const MAX_TRANSACTION_INDEX = 3;

export const ANIMATION_CLASS_MAP = {
  categorizeLife: 'animate-cardSwipeLeft',
  categorizeNotNow: 'animate-cardSwipeLeft',
  categorizeWork: 'animate-cardSwipeRight',
  categorizeApprove: 'animate-cardSwipeRight',
  categorizeSplit: 'animate-cardSwipeRight',
};
